function UnCheck(props: any) {
    return ( 
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"  > 
            
                    <path d="M1.97925 18.0208V1.95834H18.0417V18.0208H1.97925ZM3.93758 16.0625H16.0626V3.93751H3.93758V16.0625Z"  /> 
            </svg> );
}

export default UnCheck;